import React from 'react'

const Pagination = ({totalPages, page, setPage}: any) => {
  const getPageNumbers = () => {
    let pages = []
    if (totalPages <= 5) {
      for (let i = 1; i <= totalPages; i++) {
        pages.push(i)
      }
    } else {
      if (page <= 3) {
        pages = [1, 2, 3, 4, 5, '...', totalPages]
      } else if (page >= totalPages - 2) {
        pages = [
          1,
          '...',
          totalPages - 4,
          totalPages - 3,
          totalPages - 2,
          totalPages - 1,
          totalPages,
        ]
      } else {
        pages = [1, '...', page - 1, page, page + 1, '...', totalPages]
      }
    }
    return pages
  }
  return (
    <nav aria-label='Page navigation'>
      <ul className='pagination mt-5'>
        <li className={`page-item ${page === 1 ? 'disabled' : ''}`}>
          <button className='page-link' onClick={() => setPage(page - 1)}>
            Previous
          </button>
        </li>
        {getPageNumbers().map((value, index) => (
          <li
            key={index}
            className={`me-3 rounded ${page === value ? '' : ''} ${
              value === '...' ? 'disabled' : ''
            }`}
          >
            <button
              className={`rounded border border-primary text-center fs-5 ${
                page === value ? 'bg-primary text-white ' : 'bg-secondary text-primary'
              }`}
              onClick={() => typeof value === 'number' && setPage(value)}
              style={{minWidth: '30px'}}
            >
              {value}
            </button>
          </li>
        ))}
        <li className={`page-item ${page === totalPages || totalPages <= 5 ? 'disabled' : ''}`}>
          <button className='page-link' onClick={() => setPage(page + 1)}>
            Next
          </button>
        </li>
      </ul>
    </nav>
  )
}

export default Pagination
